import TabelaCombustiveisMonofasicaService from "@/services/TabelaCombustiveisMonofasicaService";

export const tabelaCombustiveisMonofasica = {
  namespaced: true,
  state: {
    tabelaCombustiveisMonofasica: {},
  },
  actions: {
    getTabelaCombustiveisMonofasica({ commit }, payload) {
      return TabelaCombustiveisMonofasicaService.GetTabelaCombustiveisMonofasica(
        payload
      ).then(
        (tabelaCombustiveisMonofasica) => {
          return Promise.resolve(tabelaCombustiveisMonofasica);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postTabelaCombustiveisMonofasica({ commit }, payload) {
      return TabelaCombustiveisMonofasicaService.PostTabelaCombustiveisMonofasica(
        payload
      ).then(
        (tabelaCombustiveisMonofasica) => {
          return Promise.resolve(tabelaCombustiveisMonofasica);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putTabelaCombustiveisMonofasica({ commit }, payload) {
      return TabelaCombustiveisMonofasicaService.PutTabelaCombustiveisMonofasica(
        payload
      ).then(
        (tabelaCombustiveisMonofasica) => {
          return Promise.resolve(tabelaCombustiveisMonofasica);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteTabelaCombustiveisMonofasica({ commit }, payload) {
      return TabelaCombustiveisMonofasicaService.DeleteTabelaCombustiveisMonofasica(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getTabelaCombustiveisMonofasicaOData({ commit }, payload) {
      return TabelaCombustiveisMonofasicaService.GetTabelaCombustiveisMonofasicaOData(
        payload
      ).then(
        (tabelaCombustiveisMonofasica) => {
          return Promise.resolve(tabelaCombustiveisMonofasica);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    atualizarTabelaCombustiveisMonofasica({ commit }, payload) {
      return TabelaCombustiveisMonofasicaService.AtualizarTabelaCombustiveisMonofasica(
        payload
      ).then(
        (tabelaCombustiveisMonofasica) => {
          return Promise.resolve(tabelaCombustiveisMonofasica);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default tabelaCombustiveisMonofasica;
